// Lobs that requires the excel template
export const EXCEL_TEMPLATE_REQUIRED_LOBS = ['140'];

// Filename of the Excel template
export const EXCEL_TEMPLATE_FILENAME = 'auskunft-neugeschaeft-template.xlsx';

export class QuestionOptions {
  static readonly HOUSING_INSURANCE_LOB_NUMBER = '140';
  static readonly housingInsuranceSumTypes = ['VALUES_1914', 'VALUE_OF_BUILDING', 'UNIT_MODEL'];
  static readonly durationUnit = ['year', 'month', 'days'];
  static readonly paymentMethod = ['annually', 'semi-annually', 'quarterly', 'monthly', 'daily', 'once'];
  static readonly lineOfBusiness = [
    '040',
    '060',
    '063',
    '081',
    '170',
    '171',
    '172',
    '174',
    '176',
    '179',
    '180',
    '181',
    '182',
    '183',
    '184',
    '185',
    '189',
    '190',
    '191',
    '192',
    '193',
    '194',
    '197',
    '199',
    '231',
    '232',
    '233',
    '290',
    '293',
    '294',
    '630',
    '140',
  ];
  static readonly expertServices = [
    '010',
    '011',
    '020',
    '021',
    '030',
    '040',
    '050',
    '060',
    '070',
    '080',
    '090',
    '100',
    '110',
    '120',
    '130',
    '140',
    '141',
  ];
  static readonly reference = ['versicherungssumme', 'umsatz'];
  static readonly defaultTerms = [
    'Gemeinsamer Allgemeiner Teil für die Allgemeine Haftpflichtversicherung, die D&O-Versicherung, die Sachversicherung und die Technischen Versicherungen (ohne Projektgeschäft) inklusive Betriebsunterbrechungsversicherungen (AT AH-D&O-Sach-TV (ohne Projektgeschäft))',
    'Allgemeine Versicherungsbedingungen für die Cyberrisiko-Versicherung (AVB Cyber)',
    'Unverbindlicher Muster-Fragebogen zur Risikoerfassung im Rahmen von Cyberversicherungen für kleine und mittelständische Unternehmen',
    'Unverbindliche Musterbausteine Cyber-Assistanceleistungen',
    'Neu strukturierte Haftpflichtbedingungen (ab 2014)',
    'Private und gewerbliche Haftpflichtbedingungen',
    'Muster-Bedingungsstrukturen',
    'Allgemeine Bedingungen für die Kfz-Versicherung (AKB 2015)',
    'Allgemeine Bedingungen für die Kfz-Versicherung von Fahrzeugen mit Versicherungskennzeichen oder Versicherungsplakette (AKB-V)',
    'Kfz-Umweltschadenversicherung (Kfz-USV) – Ergänzende Bedingungen für die Kfz-Versicherung von Umweltschäden',
    'Sonderbedingungen zur Kfz-Haftpflicht- und Kaskoversicherung für Kfz-Handel und -Handwerk (KfzSBHH)',
    'Versicherungsschutz für Kfz-Betriebe - Erläuterungen, Hinweise, Beispiele zu den verschiedenen Versicherungsarten',
    'Bedingungen für den Unfallmeldedienst (UMD)',
    'Allgemeine Versicherungsbedingungen für versicherungspflichtige klinische Prüfungen von Arzneimitteln/Jahresvertrag (AVB-Prob/AMG-JV)',
    'Allgemeine Versicherungsbedingungen für eine versicherungspflichtige klinische Prüfung von Arzneimitteln (AVB-Prob/AMG-Objekt)',
    'Allgemeine Versicherungsbedingungen für eine versicherungspflichtige klinische Prüfung oder versicherungspflichtige sonstige klinische Prüfungen von Medizinprodukten bzw. für eine versicherungspflichtige Leistungsstudie von In-vitro-Diagnostika (AVB-Prob/MP-IVD-Objekt)',
    'Allgemeine Versicherungsbedingungen für versicherungspflichtige klinische Prüfungen oder versicherungspflichtige sonstige klinische Prüfungen von Medizinprodukten bzw. für versicherungspflichtige Leistungsstudien von In-vitro-Diagnostika/Jahresvertrag (AVB-Prob/MP-IVD-JV)',
    'Allgemeine Versicherungsbedingungen für nicht der Versicherungspflicht unterliegende klinische Prüfungen/Jahresvertrag (AVB-Prob/NV-JV)',
    'Allgemeine Versicherungsbedingungen für eine nicht der Versicherungspflicht unterliegende klinische Prüfung (AVB-Prob/NV-Objekt)',
    'Allgemeine Versicherungsbedingungen für die Haftpflichtversicherung für die genehmigte deckungsvorsorgepflichtige Anwendung radioaktiver Stoffe oder ionisierender Strahlung am Menschen in der medizinischen Forschung ohne Durchführung einer nach AMG oder MPG versicherungspflichtigen klinischen Prüfung (AVB Strl-HV)',
    'Allgemeine Versicherungsbedingungen für die Zusatz-Haftpflichtversicherung zur Probandenversicherung für die genehmigte deckungsvorsorgepflichtige Anwendung radioaktiver Stoffe oder ionisierender Strahlung am Menschen bei Durchführung einer nach AMG oder MPG versicherungspflichtigen klinischen Prüfung (AVB Strl-Zusatz-HV)',
    'Allgemeine Bedingungen für die Rechtsschutzversicherung (ARB 2021)',
    'Allgemeine Bedingungen für den Fahrer-Rechtsschutz (ARB 2012-D)',
    'Allgemeine Bedingungen für die Gesamtkombination Privat/Firmen (ARB 2012-GK)',
    'Allgemeiner Teil der Versicherungsbedingungen für die Reiseversicherung 2008/2021 (AT-Reise 2008/2021)',
    'Besondere Versicherungsbedingungen für die Reiserücktrittkostenversicherung 2008/2021 (VB-Reiserücktritt 2008/2021)',
    'Besondere Versicherungsbedingungen für die Reiseabbruchversicherung 2008/2021 (VB-Reiseabbruch 2008/2021)',
    'Besondere Versicherungsbedingungen für die Reisegepäckversicherung 2008/2021 (VB-Reisegepäck 2008/2021)',
    'Allgemeine Versicherungsbedingungen für die Reiserücktrittskostenversicherung 2002/2021 (ABRV 2002/2021)',
    'Allgemeine Bedingungen für die Versicherung von Reisegepäck 1992/2021 (AVB Reisegepäck 1992/2021)',
    'Allgemeine Sachversicherungen',
    'Betriebsunterbrechung – Allgemeine Sachversicherung',
    'Betriebsschließungsversicherung',
    'Sonstige Versicherungen für Firmenkunden',
    'Besondere Bedingungen für die Versicherung weiterer Elementarschäden (BWE 2010)',
    'Hausratversicherung',
    'Glasversicherung',
    'Wohngebäudeversicherung',
    'Allgemeine Versicherungsbedingungen für den Haus- und Wohnungs-Schutzbrief (AVHW)',
    'Allgemeine Versicherungsbedingungen für den Auto- und Reise-Schutzbrief (AVAR)',
    'Allgemeine Versicherungsbedingungen für den Fahrrad-Schutzbrief',
    'Technische Versicherungen',
    'Betriebsunterbrechung – Technische Versicherung',
    'Allgemeine Unfallversicherungsbedingungen (AUB 2020)',
    'Allgemeine Bedingungen für die Unfallversicherung mit garantierter Beitragsrückzahlung (AB UBR)',
    'Allgemeine Versicherungsbedingungen für die Kinder-Invaliditätsversicherung bei Krankheit und Unfall (KIV 2014)',
    'Besondere und Zusatzbedingungen für die Unfallversicherung',
    'DTV-Bedingungen für die laufende Versicherung (Mantelvertrag) von Schiffbaurisiken 1998/2019 (AVB Schiffbau 1998/2019)',
    'DTV Open Policy Conditions (Master Agreement) for Ship Builder’s Risk Insurance 1998/2019)',
    'DTV-Bedingungen für Überwachungs- und Feuerlöschmaßnahmen für die Versicherung von Bau-, Umbau- und Reparaturrisiken von Schiffen 2000/2008',
    'Allgemeine Bedingungen für die Versicherung von Flusskasko-Risiken 2008/2013 (AVB Flusskasko 2008/2013)',
    'Instruktionen für Sachverständige in der Binnenschiffahrt 2008',
    'Allgemeine Bedingungen für die Versicherung von Flusskasko-Risiken 2000/2008(AVB Flusskasko 2000/2008)',
    'Instruktionen für Sachverständige in der Binnenschifffahrt 2002/2008',
    'Allgemeine Bedingungen für die Versicherung von Mannschaftseffekten in der Binnenschifffahrt 1994/2008 (AVB Mannschaftseffekten 1994/2008)',
    'Besondere Bedingungen für die Versicherung schwimmender Baggereianlagen 2004/2008 (BB Baggereianlagen 2004/2008)',
    'Fragebogen für die Flusskasko-Versicherung, Fassung 2008',
    'Luftfahrt-Haftpflichtversicherungs-Bedingungen für Luftfahrzeughalter und Luftfrachtführer',
    'Aviation Liability Insurance Conditions for Aircraft Operators and Carriers, version 2007',
    'Luftfahrt-Kaskoversicherungs-Bedingungen',
    'Aviation Hull Insurance Conditions, version 2008',
    'Luftfahrt-Unfallversicherungs-Bedingungen',
    'Aviation Accident Insurance Conditions, version 2007',
    'Produktinformationsblatt für die Luftfahrt-Unfallversicherung',
    'Product information sheet for aviation accident insurance',
    'Luftfahrt Produkt-Haftpflichtversicherungs-Bedingungen',
    'Besondere Bedingungen und Risikobeschreibungen für die Erweiterte Produkt-Haftpflichtversicherung von Herstellungs- und Handelsbetrieben von Luftfahrzeugteilen(LePHB 2015)',
    'Erläuterungen zu LePHB 2015',
    'DTV – Allgemeine Deutsche Seeschiffsversicherungsbedingungen 2009 (DTV-ADS 2009)',
    'DTV German Standard Terms and Conditions of Insurance for Ocean-Going Vessels 2009 (DTV-ADS 2009)',
    'Anlage zu den DTV – Allgemeine Deutsche Seeschiffsversicherungsbedingungen 2009 (Anlage-DTV-ADS 2009)',
    'Annex to the DTV – German Standard Terms and Conditions of Insurance for Ocean-Going Vessels 2009 (Annex-DTV-ADS 2009)',
    'DTV-AVB-Ausstellungsversicherung 2010 (DTV-Ausstellung 2010)',
    'Besondere Versicherungsbedingungen für die Reiserücktrittkostenversicherung 2008/2021',
    '(VB-Reiserücktritt 2008/2021)',
    'DTV-Valoren-Transportversicherungsbedingungen 2000/2008 (DTV-Valoren 2000/2008)',
    'Bestimmungen für die laufende Versicherung (DTV-Valoren 2000/2008)',
    'Allgemeine Bedingungen für die Versicherung von Schmuckwaren-, Uhren- und Bijouterie-Reiselagern 1988/2008 (AVB Reiselager Schmuck 1988/2008)',
    'Kraftfahrzeug-Sonderbestimmungen zu den AVB Reiselager Schmuck 1988/2008',
    'Allgemeine Bedingungen für die Versicherung von Musterkollektionen 1994/2008',
    '(AVB Musterkollektionen 1994/2008)',
    'Allgemeine Bedingungen für die Versicherung von Musikinstrumenten 1994/2021 (AVB Musikinstrumente 1994/2021)',
    'Allgemeine Bedingungen für die Versicherung Jagd- und Sportwaffen nebst Zubehör 1994/2021 (AVB Jagd- und Sportwaffen 1994/2021)',
    'Sonderbedingungen für die Neuwert-Versicherung von Jagd- und Sportwaffen nebst Zubehör 1994/2021 (SB Jagd- und Sportwaffen 1994/2021)',
    'Allgemeine Bedingungen für die Fotoapparate-Versicherung 1985/2021 (AVB Fotoapparate 1985/2021)',
    'Allgemeine Bedingungen für die Camping-Versicherung 1985/2021 (AVB Camping 1985/2021)',
    'Allgemeine Bedingungen für die Versicherung von Juwelen, Schmuck- und Pelzsachen im Privatbesitz 1985/2021 (AVB Schmuck und Pelze 1985/2021)',
    'Allgemeine Bedingungen für die Reiserücktrittskostenversicherung 2002/2021 (ABRV 2002/2021)',
    'DTV-Verkehrshaftungsversicherungs-Bedingungen für die laufende Versicherung für Frachtführer, Spediteure und Lagerhalter 2003/2011 (DTV-VHV laufende Versicherung 2003/2011)',
    'DTV Terms & Conditions of Liability Insurance for Open-Cover Policies of Carriers, Freight Forwarders and Warehouse Operators 2003/2011 (DTV-VHV Open Policy 2003/2011)',
    'Erläuterungen zu Ziff. 7.1.5(DTV-VHV laufende Versicherung 2003/2011)',
    'Besondere Bedingungen für die Beförderung und Lagerung hochwertiger Güter 2005/2008(BB hochwertige Güter 2005/2008)',
    'Allgemeine Bedingungen für die laufende Versicherung gegen Zoll- und Abgabenforderungen 2005/2018 (DTV-AVB Zoll 2005/2018)',
    'DTV-Güterversicherungsbedingungen 2000/2011 (DTV-Güter 2000/2011)',
    'Volle Deckung',
    'All Risks',
    'Eingeschränkte Deckung',
    'Limited Cover',
    'Bestimmungen für die laufende Versicherung',
    'Neuerungen 2020 (Erklärvideo)',
    'Lagerfragebogen – Risiko-Ersterfassung– Basisangaben',
    'Storage Questionnaire – initial risk recording– basic data',
    'Lagerfragebogen – Risiko-Ersterfassung– weitere Angaben',
    'Storage Questionnaire – initial risk recording– further data',
    'Open Policy',
    'Besondere Bedingungen für die Versicherung von Ertragsausfallschäden',
    'Special Conditions for the insurance of Loss of Income Damage (Project and Construction Business)',
    'Besondere Bedingungen für die Versicherung von Umzugsgut',
    'Special Terms and Conditions for the Insurance of Removal Goods',
    'Besondere Bedingungen für die laufende Versicherung von Ausstellungen und Messen',
    'Special Terms and Conditions for the Open Policy of Goods at Exhibitions and Trade Fairs',
    'Zertifikat / Certificate, Fassung Januar 2011',
    'Allgemeine Bedingungen für die Kasko-Versicherung von Wassersportfahrzeugen 2008 (AVB Wassersportfahrzeuge 2008)',
    'Allgemeine Bedingungen für die Kasko-Versicherung von Wassersportfahrzeugen 1985/2008 (AVB Wassersportfahrzeuge 1985/2008)',
  ];

  static readonly defaultClauses = [
    'Unverbindliche Muster-Sanktionsklausel (Stand 03/2020)',
    'Klausel für den Ausschluss von Cyber- und Blackoutschäden sowie den optionalen Wiedereinschluss von Cyberschäden in der Transportversicherung (Cyber-/Blackout-Klausel)',
    'Marine Cyber and Blackout Exclusion and Optional Cyber Write Back Clause (Cyber/Blackout Clause)',
    'Sanktionsklausel',
    'DTV-Donauklausel zu den AVB Flusskasko 2000/2008',
    'DTV-Flusskasko-Übernahmeklausel 1995/2008 zu den AVB Flusskasko 2000/2008',
    'Klausel für den Ausschluss von Schäden durch eine bedrohliche übertragbare Krankheit in der Transportversicherung („Pandemie-Ausschlussklausel“)',
    'Clause for the Exclusion of Loss/Damage due to a Dangerous Communicable Disease for the Use in Marine Insurance (“Pandemic Exclusion Clause”)',
    'Wiedereinschlussklausel „Bedrohliche übertragbare Krankheit in der Schiffsversicherung“',
    'Write back Clause “Dangerous Communicable Disease for the Use in Marine Insurance for Vessels”',
    'Sanctions Clause, version 2011',
    'Hypotheken-Klausel, 2004',
    'Wiedereinschlussklausel Streik, Terror, Aufruhr (DTV-Ausstellung 2010)',
    'Kriegsklausel (DTV-Valoren 2000/2008)',
    'Wiedereinschlussklausel Streik, Terror, Aufruhr (DTV-Valoren 2000/2008)',
    'Beschlagnahmeklausel (DTV-Valoren 2000/2008)',
    'Sonderbedingungen und Klauseln zu den AVB Musikinstrumente 1994/2021 (SB Musikinstrumente 1994/2021)',
    'Klauseln zu den AVB Fotoapparate 1985/2021 (Klauseln AVB Fotoapparate 1985/2021)',
    'Klauseln zu den AVB Camping 1985/2021 (Klauseln AVB Camping 1985/2021)',
    'Klauseln zu den AVB Schmuck und Pelze 1985/2021 (Klauseln AVB Schmuck und Pelze 1985/2021)',
    'Klauseln zu den AVB Reisegepäck 1992/2021 (Klauseln AVB Reisegepäck 1992/2021)',
    'Explanatory notes on Clause 7.1.5(DTV-VHV Open Policy 2003/2011)',
    'Wiedereinschlussklausel „Bedrohliche übertragbare Krankheit in der Verkehrshaftungsversicherung“',
    'Write back Clause “Dangerous Communicable Disease for the Use in Liability Insurance for Carriers, Freight Forwarder and Warehouse Operators”',
    'Kriegsklausel',
    'War Clause',
    'Streik- und Aufruhrklausel',
    'Strikes, Riots and Civil Commotions Clause',
    'Beschlagnahmeklausel',
    'Confiscation Clause',
    'Klassifikations- und Altersklausel',
    'Classification and Age Clause',
    'Bergungs- und Beseitigungsklausel',
    'Salvage and Debris Removal Clause',
    'Kriegswerkzeugklausel',
    'Derelict Weapons of War Clause',
    'Isotopenklausel',
    'Radioactive Isotopes Clause',
    'Bewegungs- und Schutzkostenklausel',
    'Cost of Relocation and Protection of Property Clause',
    'Schutz- und Konditionsdifferenzversicherungsklausel',
    'Contingency and DIC Insurance Clause',
    'Güterfolgeschadenklausel',
    'Consequential Losses Clause',
    'Vermögensschadenklausel',
    'Pure Financial Losses Clause',
    'Wiedereinschlussklausel „Bedrohliche übertragbare Krankheit in der Güterversicherung“',
    'Write back Clause “Dangerous Communicable Disease for the Use in Cargo Insurance”',
  ];

  static readonly typOfInsuredAmount = ['sumInsured',
    'maximumLiabilitySum',
    'fixedAssessment',
    'perMeansOfTransport',
    'maximumStorage',
    'hullSumPerVessel',
    'sublimit',
    'personalInjury',
    'propertyDamage',
    'financialLosses',
    'content',
    'building',
    'machine'

  ];
  //Keep none as the first Element, since it is referenced by index 0 at multiple points
  static readonly typeOfDeductible = ['none', 'deduction', 'integral', 'year'];
  static readonly referenceValues = ['sumInsured', 'coverageAmount', 'annualSales'];

  static readonly countryCodes = ['DE', 'AF', 'EG', 'AL', 'DZ', 'AD', 'AO', 'AI', 'AQ', 'AG', 'GQ', 'AR', 'AM', 'AW', 'AZ', 'ET', 'AU', 'BS', 'BH', 'BD', 'BB', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'MM', 'BO', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'CL', 'CN', 'CX', 'CK', 'CR', 'DK', 'DJ', 'DM', 'DO', 'EC', 'SV', 'CI', 'ER', 'EE', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'GH', 'GI', 'GD', 'GR', 'GL', 'UK', 'GB', 'GP', 'GU', 'GT', 'GN', 'GW', 'GY', 'HT', 'HM', 'HN', 'HK', 'IN', 'ID', 'IQ', 'IR', 'IE', 'IS', 'IL', 'IT', 'JM', 'JP', 'YE', 'JO', 'YU', 'KY', 'KH', 'CM', 'CA', 'CV', 'KZ', 'KE', 'KG', 'KI', 'CC', 'CO', 'KM', 'CG', 'CD', 'HR', 'CU', 'KW', 'LA', 'LS', 'LV', 'LB', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MP', 'MA', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MK', 'MX', 'FM', 'MZ', 'MD', 'MC', 'MN', 'MS', 'NA', 'NR', 'NP', 'NC', 'NZ', 'NI', 'NL', 'AN', 'NE', 'NG', 'NU', 'KP', 'NF', 'NO', 'OM', 'AT', 'PK', 'PS', 'PW', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR', 'QA', 'RE', 'RW', 'RO', 'RU', 'LC', 'ZM', 'AS', 'WS', 'SM', 'ST', 'SA', 'SE', 'CH', 'SN', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB', 'SO', 'GS', 'ES', 'LK', 'SH', 'KN', 'PM', 'VC', 'KR', 'ZA', 'SD', 'SR', 'SJ', 'SZ', 'SY', 'TJ', 'TW', 'TZ', 'TH', 'TP', 'TG', 'TK', 'TO', 'TT', 'TD', 'CZ', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'HU', 'UY', 'UZ', 'VU', 'VA', 'VE', 'AE', 'US', 'VN', 'VG', 'VI', 'WF', 'BY', 'EH', 'CF', 'ZW', 'CY'];
  static readonly currency = ['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV', 'BRL', 'BSD', 'BTN', 'BWP', 'BYR', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF', 'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUC', 'CUP', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LTL', 'LVL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STD', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'USS', 'UYI', 'UYU', 'UZS', 'VEF', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XFU', 'XOF', 'XPD', 'XPF', 'XPT', 'XTS', 'XXX', 'YER', 'ZAR', 'ZMW'];

}
